<template>
  <div class="mt-6 text-center">
    <img src="~/assets/img/dualring.gif" class="inline h-16" />
  </div>
</template>
